export const breakpoints = {
  values: {
    xs: 0,
    sm: 750,
    md: 1080,
  },
};
